import {Link, useLocation, useNavigate, useNavigation} from 'react-router-dom'
import { useContext, useEffect, useState } from 'react'
import HomeIcon from '@mui/icons-material/Home';
import BookIcon from '@mui/icons-material/Book';
import SellIcon from '@mui/icons-material/VideoCall';
import LoginIcon from '@mui/icons-material/Login';
import SignupIcon from '@mui/icons-material/PersonAdd';
import DownIcon from '@mui/icons-material/ArrowDropDown';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PersonIcon from '@mui/icons-material/Person';
import LanguageIcon from '@mui/icons-material/Language';
import logo from '../assets/logo.png'
import { appContext } from '../Context/appProvider';
import { sellerBaseUrl } from '../constants';
import { settingsContext } from '../Context/settingsProvider';

export default function SideBar(){
    const location = useLocation()
    const _path = location.pathname
    const navigate  = useNavigate()
    const {showSidebar, setShowSidebar, categories, token} = useContext(appContext)
    const {t, languages, changeLang, userLang, setChooseLang} = useContext(settingsContext)
    
    const links = [
        {path: '/', title: t('HOME'), Icon: HomeIcon},
        {path: categories ? '/category/' + categories?.at(0)?.name.replace(/ /g, '-') : '', title: t('COURSES'), Icon: BookIcon},
        {path: sellerBaseUrl, title: t('SELL_COURSE'), Icon: SellIcon, external: true},
        {path: token ? '/profile?tab=courses' : '/login', title: t('MY_COURSES'), Icon: LibraryBooksIcon},
        {path: token ? '/profile?tab=wishlist' : '/login', title: t('WISHLISTS'), Icon: FavoriteIcon},
        {path: token ? '/profile?tab=account' : '/login', title: t('ACCOUNT'), Icon: PersonIcon}, 
    ]

    return (
        <div className={'z-[99999] max-md:!w-[200px] group hover:w-[200px] max-md:hover:w-[auto] overflow-hidden fixed top-0 bottom-0 shadow-sm bg-white gap-4 flex flex-col pt-4 pb-6 overflow-auto transition-all duration-500 ease-in-out pt-[70px] ' + (showSidebar ? 'max-md:translate-x-[0] w-[200px]' : 'max-md:translate-x-[-100%] w-[50px]')}>
            {/* <Link to='/' className='self-center max-md:hidden'>
                <img src={logo} className='w-[60px] object-contain' />
            </Link> */}
            <div className='flex flex-col overflow-hidden'>
                {links.map(item => (
                    <Link to={item.path} onClick={() => item.external ? window.open(item.path, '_blank') : setShowSidebar(false)} className={`flex items-center gap-4 p-3 ${_path == item.path ? 'text-main' : ''}`}>
                        <item.Icon className='group-hover:text-main text-black' style={{fontSize: 23, color: _path == item.path ? "#6622cf" : '#00000099'}} >Filled</item.Icon>
                        <p className='text-sm whitespace-nowrap hover:text-main' style={{fontWeight: _path == item.path ? 'bold' : 'normal'}}>{item.title}</p>
                    </Link>
                ))}

                {!token && (
                    <>
                        <Link to='/login' onClick={() => setShowSidebar(false)} className={`items-center gap-2 border-t-[1px] border-t-[#00000040] hidden max-md:flex p-3 ${_path == '/login' ? 'text-main' : ''}`}>
                                <LoginIcon color={_path == '/login' ? "#ffffff" : '#000000'} style={{fontSize: 22}} >Filled</LoginIcon>
                                <p className='text-sm' style={{fontWeight: _path == '/login' ? 'bold' : 'normal'}}>{t('LOGIN')}</p>
                        </Link>
                        <Link to='/signup' onClick={() => setShowSidebar(false)} className={`items-center gap-2 hidden max-md:flex p-3 ${_path == '/signup' ? 'text-main' : ''}`}>
                                <SignupIcon color={_path == '/signup' ? "#ffffff" : '#000000'} style={{fontSize: 22}} >Filled</SignupIcon>
                                <p className='text-sm' style={{fontWeight: _path == '/signup' ? 'bold' : 'normal'}}>{t('SIGNUP')}</p>
                        </Link> 
                    </>
                )}
            </div>
            <div className='flex justify-around mt-[auto]'>
                <div className='flex items-center gap-1'>
                    {/* <label for='lang' className='text-[11px]'>Language</label> */}
                    <LanguageIcon color='#000000' size={13}>Filled</LanguageIcon>
                    <button onClick={() => setChooseLang(true)} className='whitespace-nowrap border-none bg-none hidden max-md:flex group-hover:flex flex items-center justify-center'>
                        <p className='text-sm'>{languages.find(l => l.value == userLang)?.label}</p>
                        <DownIcon>Filled</DownIcon>
                    </button>
                </div>
                {/* <button onClick={() => {
                    // logOut()
                    setTimeout(() => navigate('/'), 1000)
                }}>
                    <LogOut color='#000000' size={20} />
                </button> */}
            </div>
          
        </div>
    )
}